module.exports = __webpack_public_path__ + "img/Uploading.75e9e853.svg";